<template>
    <div class="multi-bet-item-container full-white-border">
        <h2 class="text-center multi-bet-header">MULTI BET</h2>
        <v-container fluid px-0 py-0>
            <v-layout row wrap>
                <v-flex xs12 md6 class="border">
                    <v-text-field v-model="stake" type=number :hide-details="hideTextFieldHints" min="0" box color="blue-grey lighten-2" label="Stake" :disabled="$store.getters.getMultipleSubmitting" @input="calculateTotalOddsAndPayout()" required></v-text-field>
                </v-flex>
                <v-flex xs12 md6 class="border">
                    <v-text-field v-model="payoutDisplay" :hide-details="hideTextFieldHints" box color="blue-grey lighten-2" label="Payout" disabled></v-text-field>
                </v-flex>
                <template v-if="$store.getters.getMultipleErrorMessage.indexOf('Price')!==-1">
                    <v-btn class="btn-submit" color="green" v-on:click="acceptChanges()">
                        ACCEPT CHANGES
                    </v-btn>
                </template>
                <template v-else-if="$store.getters.getMultipleAccepted">
                    <v-btn class="btn-submit" color="blue" v-on:click="submitNow()">
                        SUBMIT NOW
                    </v-btn>
                    <v-alert :value="$store.getters.getMultipleSuccess" dismissible type="success">
                        Bet Successfully Placed.
                    </v-alert>
                </template>
                <template v-else-if="!$store.getters.getMultipleAccepted">
                    <v-btn :disabled="timeout || stake < 1 || marketStatusId || marketDetailStatus" class="btn-submit" v-on:click="checkLoggedIn()" color="blue">
                        {{submitText}}
                    </v-btn>
                    <v-alert :value="$store.getters.getMultipleSuccess" dismissible type="success">
                        Bet Successfully Placed.
                    </v-alert>
                    <v-alert v-model="error" dismissible type="error">
                        {{$store.getters.getMultipleErrorMessage}}
                    </v-alert>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

    import Utils from '../utils/utils';

    export default {
        name: 'MultiBetItem',
        props: {
            betSelections: Array,
            betSubmit: Function
        },
        data() {
            return {
                stake: null,
                payout: 0,
                payoutDisplay: null,
                totalOdds: 0,
                submitText: "SUBMIT MULTIPLE",
                timeout: false,
                countDown: 10,
                hideTextFieldHints: true,
                marketDetailStatus: false,
                marketStatusId: false,
                acceptedChanges: false,
                submittingNow: false,
                error: false
            }
        },
        computed: {
            Autheticated() {
                return this.$store.getters.isAutheticated
            }
        },
        methods: {
            calculateTotalOddsAndPayout() {
                this.totalOdds = 1;
                this.payout = 0;
                this.payoutDisplay = 0;
                let l = this.betSelections.length;
                for (let i = 0; i < l; i++) {
                    const selection = this.betSelections[i];
                    this.totalOdds *= (selection && selection.betleg && selection.betleg.odds + 1);
                }
                this.totalOdds -= 1;
                this.payout = this.stake * this.totalOdds;
                this.payoutDisplay = Utils.roundDown(this.payout, 2);
                if (this.payoutDisplay <= 0) {
                    this.payoutDisplay = null
                }
            },
            checkLoggedIn() {
                if (this.$store.getters.getMultipleError) {
                    this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: false, accepted: false });
                    this.error = false
                }
                this.$store.dispatch('storeCookieAccessToken').then(() => {
                    if (this.$store.getters.accessToken !== null) {
                        this.$store.dispatch('login', { authToken: this.$store.getters.accessToken }).then(() => {
                            this.startBetSubmit();
                        })
                    } else {
                        this.$store.dispatch('setMultipleSubmission', { success: false, error: true, errorMessage: 'You need to be logged in to submit a bet', submitting: false, accepted: false });
                    }
                });
            },
            updateMultipleInfo(stake, totalOdds, payout) {
                this.$store.dispatch('updateMultipleTotals', {
                    totalStake: stake,
                    totalOdds: totalOdds,
                    totalPayout: payout
                });
            },
            startBetSubmit() {
                const currentBetSelections = Utils.deepClone(this.betSelections);
                let priceDrift = this.$store.getters.selectedOddsChange;
                this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: true, accepted: false });
                let localTotalOdds = this.totalOdds
                this.updateMultipleInfo(this.stake, localTotalOdds, this.payout);
                this.timeout = true;
                this.$store.dispatch('setIsSubmitting', true);
                var setCountDown = setInterval(() => {
                    this.countDown--;
                    this.submitText = 'Wait ' + this.countDown;
                    if (this.countDown === 0) {
                        if (priceDrift === 'Accept any odds change') {
                            clearInterval(setCountDown);
                            this.calculateTotalOddsAndPayout();
                            this.updateMultipleInfo(this.stake, this.totalOdds, this.payout);
                            this.submitText = 'SUBMIT MULTIPLE';
                            this.timeout = false;
                            this.countDown = 10;
                            this.betSubmit(this.betSelections);
                            this.$store.dispatch('setIsSubmitting', false);
                        }
                        else if (priceDrift === 'Accept higher odds change') {
                            let oddsDecreased = true
                            for (let i = 0; i < currentBetSelections.length; i++) {
                                if (currentBetSelections[i].betleg.odds > this.betSelections[i].betleg.odds) {
                                    oddsDecreased = false
                                }
                            }
                            if (oddsDecreased) {
                                clearInterval(setCountDown);
                                this.calculateTotalOddsAndPayout();
                                this.updateMultipleInfo(this.stake, this.totalOdds, this.payout);
                                this.submitText = 'SUBMIT MULTIPLE';
                                this.timeout = false;
                                this.countDown = 10;
                                this.betSubmit(this.betSelections);
                                this.$store.dispatch('setIsSubmitting', false);
                            }
                            else {
                                clearInterval(setCountDown);
                                this.submitText = 'SUBMIT MULTIPLE';
                                this.timeout = false;
                                this.countDown = 10;
                                this.betSubmit(currentBetSelections);
                                this.$store.dispatch('setIsSubmitting', false);
                            }

                        }
                        else {
                            clearInterval(setCountDown);
                            this.submitText = 'SUBMIT MULTIPLE';
                            this.timeout = false;
                            this.countDown = 10;
                            this.betSubmit(currentBetSelections);
                            this.$store.dispatch('setIsSubmitting', false);
                        }
                    }
                }, 1000);
                return this.countDown * 1000;
            },
            submitNow() {
                const currentBetSelections = Utils.deepClone(this.betSelections);
                this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: true, accepted: false });
                let priceDrift = this.$store.getters.selectedOddsChange;
                //this.$store.dispatch('setselectedOddsChange', 3)
                this.$store.dispatch('setselectedOddsChange', priceDrift)
                this.updateMultipleInfo(this.stake, this.totalOdds, this.payout);
                this.submittingNow = false;
                this.betSubmit(currentBetSelections);
            },
            acceptChanges() {
                this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: true, accepted: true });
                this.submittingNow = true;
                this.calculateTotalOddsAndPayout();
            },
        },
        mounted() {
            for (let i = 0; i < this.betSelections.length; i++) {
                this.$store.watch((state, getters) => getters.oddChange(this.betSelections[i] && this.betSelections[i].marketDetailId),
                    (newValue, oldValue) => {
                        if (newValue !== oldValue) {
                            if (!this.$store.getters.getMultipleSubmitting) {
                                this.calculateTotalOddsAndPayout();
                            }
                        }
                    });
                this.$store.watch((state, getters) => getters.marketStatusIdChange(this.betSelections[i] && this.betSelections[i].marketDetailId),
                    (newValue) => {
                        if (newValue !== 1) {
                            this.marketStatusId = true;
                        }
                        else
                            this.marketStatusId = false;
                    });
                this.$store.watch((state, getters) => getters.marketDetailStatusChange(this.betSelections[i] && this.betSelections[i].marketDetailId),
                    (newValue) => {
                        if (newValue !== 1) {
                            this.marketDetailStatus = true
                        }
                        else
                            this.marketDetailStatus = false;
                    });
            }
            this.$store.watch((state, getters) => getters.betSelectionCount,
                (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (!this.$store.getters.getMultipleSubmitting) {
                            this.calculateTotalOddsAndPayout()
                        }
                    }
                });
            this.$store.watch((state, getters) => getters.getMultipleTotals,
                (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (newValue.multipleTotals.totalStake === 0) {
                            this.stake = 0;
                            this.payoutDisplay = null;
                        }
                    }
                });
            this.$store.watch((state, getters) => getters.getMultipleError,
                (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        this.error = newValue;
                    }
                });
        }
    }
</script>

<style scoped>
    .border {
        border: 0.5px solid #FFFFFF !important;
    }

    .multi-bet-item-container {
        margin-top: 10px;
        padding: 0px 10px 10px 10px;
        background-color: #343434;
    }

    .multi-bet-item-container button.btn-submit.v-btn {
        height: 30px;
        font-size: 12px;
    }

    .btn-submit {
        width: 100%;
        margin: 16px 0 0 0;
        color: white;
        display: inline-block;
        font-weight: 600;
    }

    .text-center {
        text-align: center;
    }

    .multi-bet-header {
        text-transform: uppercase;
        background-color: #62418d;
        padding: 8px 0px;
        font-size: 15px;
        margin-left: -10px;
        margin-right: -10px;
        margin-bottom: 10px;
    }
</style>
